import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { CircularLoadingWithTextProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { CircularProgress, Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const CircularLoadingWithText: React.FC<CircularLoadingWithTextProps> = (props) => {
  const { loadingText } = props;
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      rowGap={2}
      className={cssExports.circularLoadingWithTextContainer}
    >
      <Grid item>
        <CircularProgress />
      </Grid>

      <Grid item className={cssExports.loadingText}>{`${
        loadingText ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Loading)
      }`}</Grid>
    </Grid>
  );
};

export default CircularLoadingWithText;
